<template>
  <div>
    <div style="height: 60px; padding-top: 10px">
      <v-img
        style="margin-left: auto; margin-right: auto"
        width="80px"
        src="../../assets/depa.png"
      ></v-img>
    </div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <v-container class="pb-12">
        <div
          class="rsu primary--text text-center mb-3"
          style="font-weight: 600; font-size: 26px"
        >
          Term and Conditions
        </div>
        <div class="termncondition">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
          velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
          occaecat cupidatat non proident, sunt in culpa qui officia deserunt
          mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur
          adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
          irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
          fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
          sunt in culpa qui officia deserunt mollit anim id est laborum.
        </div>
        <div class="px-6">
          <v-checkbox value="value">
            <template v-slot:label>
              <span style="color: black">
                I accept terms and conditions and privacy policy
              </span>
            </template>
          </v-checkbox>
        </div>

        <div class="submitbtn text-center">
          <v-btn
            @click="next"
            color="primary"
            class="text-capitalize"
            depressed
            block
            >Next</v-btn
          >
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    next() {
      this.query.view = "Registration";
    },
  },
};
</script>

<style lang="scss">
.termncondition {
  border: 3px solid #efefef;
  padding: 12px;
  border-radius: 5px;
  height: 50vh;
  background-color: #f5f5f5;
  overflow: auto;
}
</style>